import type { ParsedConnectionStats } from 'webrtc-issue-detector';
import type { LDTransport } from '../../types/mediasoup';
import type StatsHandler from './StatsHandler';

interface ConnectionStatManagerParams {
  transport: LDTransport;
  statsHandler: StatsHandler;
}

export default class ConnectionStatManager {
  #connectionStats?: ParsedConnectionStats;

  constructor({ transport, statsHandler }: ConnectionStatManagerParams) {
    this.handleWebRTCStats(transport, statsHandler);
  }

  get connectionStats(): ParsedConnectionStats | undefined {
    return this.#connectionStats;
  }

  private handleWebRTCStats(transport: LDTransport, statsHandler: StatsHandler): void {
    statsHandler.addConnectionHandler(transport.id, this.setConnectionStats.bind(this));
    transport.observer.once('close', () => {
      statsHandler.removeConnectionHandler(transport.id);
    });
  }

  private setConnectionStats(stats: ParsedConnectionStats): void {
    this.#connectionStats = stats;
  }
}
